import React from 'react';
import {
  arrayOf,
  string,
  shape,
  bool,
} from 'prop-types';
import { Button, Link } from 'components/common';

import './VerticalsList.scss';

const VerticalsList = ({ verticals }) => (
  <div className="vertist-list">
    <div className="vertical-list-buttons">
      {verticals && verticals.map(({
        name,
        value,
        href,
        isSelected,
      }) => (
        <span className="vertical-list-button" key={name}>
          <Link to={href}>
            <Button small tertiary={!isSelected}>
              {value}
            </Button>
          </Link>
        </span>
      ))}
    </div>
  </div>
);

VerticalsList.propTypes = {
  verticals: arrayOf(
    shape({
      name: string.isRequired,
      value: string.isRequired,
      href: string.isRequired,
      isSelected: bool,
    })
  ).isRequired,
};

export default VerticalsList;
